





































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import Banner from 'frontend/components/Banner.vue';
import Landing from 'frontend/views/landing/Landing.vue';
import LandingHeaderV2 from 'frontend/views/landing/LandingHeaderV2.vue';
import LandingHeroV2 from 'frontend/views/landing/LandingHeroV2.vue';
import Summary from 'frontend/views/index/Summary.vue';
import LearningPaths from 'frontend/views/landing/LearningPaths.vue';
import EmphasisText from 'frontend/components/EmphasisText.vue';
import PrinciplesOfLearning from 'frontend/views/index/PrinciplesOfLearning.vue';
import JoinCTA from 'frontend/views/landing/JoinCTA.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import JoinClassroomModal from 'frontend/views/index/JoinClassroomModal.vue';
import NovaSponsorModal from 'frontend/views/index/NovaSponsorModal.vue';

import ChurnTrackingBlock from 'frontend/components/util/ChurnTrackingBlock.vue';

import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';
import SavvyFlow from 'frontend/components/util/Savvy/SavvyFlow.vue';
import { loggedOutHomepageFlowId } from 'frontend/components/util/Savvy/SavvyConstants';
import { meta } from 'frontend/utils/decorators';

import ReferAFriendModal from 'frontend/views/referral/components/ReferAFriendModal.vue';
import { RefereeDiscountContext } from 'frontend/types/referral';
import { ExperimentGetter } from 'frontend/types';

@Component({
  components: {
    Banner,
    ReferAFriendModal,
    ChurnTrackingBlock,
    Landing,
    LandingHeaderV2,
    LandingHeroV2,
    Summary,
    EmphasisText,
    LearningPaths,
    PrinciplesOfLearning,
    JoinCTA,
    LandingFooter,
    ResponsiveImage,
    JoinClassroomModal,
    NovaSponsorModal,
    SavvyFlow,
    AccountDeactivatedModal: () =>
      // tslint:disable-next-line:space-in-parens
      import(
        /* webpackChunkName: 'AccountDeactivatedModal' */ 'frontend/views/index/AccountDeactivatedModal.vue'
      ),
    SponsorModal: () =>
      // tslint:disable-next-line:space-in-parens
      import(/* webpackChunkName: 'SponsorModal' */ 'frontend/views/index/SponsorModal.vue'),
    PrivacyBanner: () =>
      // tslint:disable-next-line:space-in-parens
      import(/* webpackChunkName: 'PrivacyBanner' */ 'frontend/views/global/PrivacyBanner.vue'),
  },
  computed: {
    ...mapState('sponsorModalInfo', ['show_sponsor_modal']),
    ...mapGetters('sponsorPbsNova', ['isPbsNovaTraffic']),
    ...mapState('accountDeactivatedMessage', ['show_just_deactivated_account_message']),
    ...mapGetters('response', ['baseUrl', 'requestPath']),
    ...mapGetters('globals', ['inExperiment', 'isAuthenticated', 'privacyProperties']),
    ...mapGetters('savvyLoggedOutHomepage', ['savvyEnabledLoggedOutHomepage']),
    ...mapState('referralModalInfo', ['referralModalInfoData']),
    ...mapState('viewedReferralModal', ['userHasSeenReferralModal']),
  },
})
export default class LoggedOutHomepage extends Vue {
  private readonly baseUrl!: string;
  private readonly requestPath!: string;
  private inExperiment!: ExperimentGetter;
  private referralModalInfoData!: RefereeDiscountContext;
  private referAFriendModalDismissed = false;
  private userHasSeenReferralModal!: boolean;

  @meta
  private metaInfo() {
    return {
      titleTemplate: 'Brilliant | Learn interactively',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Brilliant - Build quantitative skills in math, science, and computer science
            with hands-on, interactive lessons.`,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `Brilliant - Build quantitative skills in math, science, and computer science
            with hands-on, interactive lessons.`,
        },
        { vmid: 'og:title', property: 'og:title', content: 'Brilliant | Learn interactively' },
        {
          vmid: 'og:image',
          property: 'og:image',
          content:
            'https://brilliant.org/site_media/version-d36afe2dd2/images/' +
            'open-graph/logged-out-home-pix-v2.png',
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: `${this.baseUrl}${this.requestPath.split('?')[0]}`,
        },
        { vmid: 'twitter:site', name: 'twitter:site', content: '@brilliantorg' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      ],
    };
  }

  get loggedOutHomepageFlowId(): string {
    return loggedOutHomepageFlowId;
  }

  private get showReferAFriendModal(): boolean {
    return (
      this.referralModalInfoData &&
      !this.userHasSeenReferralModal &&
      !this.referAFriendModalDismissed
    );
  }

  private closeReferAFriendModal() {
    this.referAFriendModalDismissed = true;
  }

  private get isExperiment(): boolean {
    return this.inExperiment('homepage_above_fold_0223', 'experiment');
  }

  private get videoUrl(): string {
    return this.isExperiment
      ? '/site_media/version-V87e099514e4/images/homepage/landingpage_cs.mp4'
      : '/site_media/version-V87e099514e4/images/homepage/brilliant-learn-visually.mp4';
  }
}
